export default __webpack_public_path__ + "static/media/s2.48727c03.png";